module.exports = __webpack_public_path__ + "static/media/7thfloor.50a78e89.jpg";